var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticClass:"profile-img",style:(_vm.style),attrs:{"src":_vm.src || _vm.defaultImg},on:{"~error":function($event){return _vm.error.apply(null, arguments)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }